export enum ArticlePlayerStates {
  paused = 'paused',
  playing = 'playing',
  error = 'error',
  waiting = 'waiting',
}
